import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

const TabModelo = ({ selectedItem, selectedColor, selectedTransmision, setSelectedTransmision, setSelectedColor }) => {
  console.log(selectedTransmision, "Selected transmision");
  console.log(selectedColor, "Selected color");
  console.log(selectedItem, "Selected item");
  console.log(selectedItem?.types.filter((t) => t.transmision === selectedTransmision)[0]);

  return selectedItem ? (
    <Col className="text-center pb-5">
      {/* <div>
        {selectedItem.types && selectedItem.types.length > 0 && (
          <div className="d-flex justify-content-center align-content-center align-items-center pt-5 pb-4">
            {selectedItem.types.map((type) => (
              <button
                className={`transmissionType ${selectedTransmision === type.transmision ? "active" : ""}`}
                onClick={() => setSelectedTransmision(type.transmision)}
              >
                {type.transmision}
              </button>
            ))}
          </div>
        )}
      </div> */}
      <div className="pb-3">
        <img src={selectedColor?.file} alt={selectedItem?.modelo} className="img-fluid" />
      </div>

      <div className="pb-5 d-flex justify-content-center flex-row">
        {selectedItem &&
          selectedItem.types.filter((t) => t.transmision === selectedTransmision)[0] &&
          selectedItem.types
            .filter((t) => t.transmision === selectedTransmision)[0]
            .colores?.map((colores) => (
              <div
                className="divColor m-1 "
                style={{ backgroundColor: colores.color, cursor: "pointer" }}
                onClick={() => setSelectedColor(colores)}
              ></div>
            ))}
      </div>

      <div>
        <h1 style={{ fontSize: 20, fontWeight: "BOLD", paddingBottom: "15px" }}>
          {selectedItem && selectedItem?.types.filter((t) => t.transmision === selectedTransmision)[0]?.title}
        </h1>
        <ul className="list-unstyled">
          <b className="disponibleEnTrasmision">{selectedItem.fondoAzul ? selectedItem.fondoAzul : null}</b>
          {selectedItem &&
            selectedItem?.types.filter((t) => t.transmision === selectedTransmision)[0] &&
            selectedItem?.types
              .filter((t) => t.transmision === selectedTransmision)[0]
              .specs?.map((spec) => <li>{spec}</li>)}
        </ul>
      </div>
      <div className="pt-4 pb-4">
        <a href={selectedItem.ficha} className="linkDefault" target="_blank" rel="noreferrer">
          Ver Ficha Técnica
        </a>
      </div>
    </Col>
  ) : (
    <p>Cargando...</p>
  );
};

export default TabModelo;
